import { render, staticRenderFns } from "./PaymentAndInvoiceTypeSelector.vue?vue&type=template&id=0b1f40fe&scoped=true&"
import script from "./PaymentAndInvoiceTypeSelector.vue?vue&type=script&lang=js&"
export * from "./PaymentAndInvoiceTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1f40fe",
  null
  
)

export default component.exports